module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAATCAYAAACZZ43PAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA1klEQVQ4y53TL0uEQRCA8fdQzH4CwSSYPAwmMYrJJibDYb1wmm0KJoPdbDBYjX4Xm0VFLtx53M/gvDJFvHkHlmX/PM8usztN80fgCsOmS2Ab82iDKtyL/sxPzHBcgtP4IiRTHJbgNH8dkgn2S3Bavw3JGHsluN2Du5B8YKeU2JAs4T4kb9jqIlnGY0hesdlFsorPkDxX4RU8BfyCtWoOHtL1N34zvACcX+Ed/erVb9I/2K3C7Xee4KAKD1NBHS0KtdV4kkr6tHryOr7i9PMSnCQjXP637xtKnS58l5QFngAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/right.png
// module id = RIg6
// module chunks = 1